import "core-js/stable";
import "regenerator-runtime/runtime";

// 3rd party
import Cocooned from "@notus.sh/cocooned";
Cocooned.start()

// common
import "../javascripts/common/base/polyfills";
import "../javascripts/common/base/rails";
import "../javascripts/common/base/smart-outline";
import "../javascripts/common/base/togglable";
import "../javascripts/common/base/togglable-cookie";
import "../javascripts/common/base/omasks";
import "../javascripts/common/components/analytics";
import "../javascripts/common/components/analytics-events";
import "../javascripts/common/components/grille";
import "../javascripts/common/components/header";
import "../javascripts/common/components/flatpickr";
import "../javascripts/common/components/choices";
import "../javascripts/common/components/a11ydialog";
import "../javascripts/common/components/search-aside";
import "../javascripts/common/components/categories-search-filter";
import "../javascripts/common/components/date-search-filter";
import "../javascripts/common/components/bundle-folders";
import "../javascripts/common/components/bundle-search";
import "../javascripts/common/components/bundle-search-api";
import "../javascripts/common/components/video-player";
import "../javascripts/common/components/live-seminar-video-player";
import "../javascripts/common/components/shepherd";
import "../javascripts/common/components/package-folders";
import "../javascripts/common/components/newsletter-banner";
import "../javascripts/common/components/news-box";
import "../javascripts/common/components/side-menu";
import "../javascripts/common/components/course-analysis-video-player";

// application
import "../javascripts/application/base/print";
import "../javascripts/application/components/hnav";
import "../javascripts/application/components/nav-bar";
import "../javascripts/application/components/layout-main";
import "../javascripts/application/components/library";
import "../javascripts/application/components/highlights";
import "../javascripts/application/components/sidebar-user";
import "../javascripts/application/components/the-article";
import "../javascripts/application/components/the-article-documents";
import "../javascripts/application/components/quiz";
import "../javascripts/application/components/post-share";
import "../javascripts/application/components/welcomebar";
import "../javascripts/application/components/paywall";
import "../javascripts/application/components/save-search-form";
import "../javascripts/application/components/education-certificate";
import "../javascripts/application/components/sortable";
import "../javascripts/application/components/seminar-booking";
import "../javascripts/application/components/seminar-suggest";
import "../javascripts/application/components/single-item-purchase";
import "../javascripts/application/components/login-modal";
import "../javascripts/application/components/user-settings";
import "../javascripts/application/components/purchase-notice";
import "../javascripts/application/components/inner-tabs";
import "../javascripts/application/components/seminar-questions";
import "../javascripts/site/components/register-email";
